<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      originalDataLayerPush: null
    }
  },

  mounted() {
    if (!window) return

    // If already handled, trigger immediately
    if (window.__consentStatus) {
      console.error('consent_status already set:', window.__consentStatus)
      this.onConsentStatus(window.__consentStatus)
      return
    }

    // Ensure dataLayer exists
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    // Check existing entries
    for (const item of window.dataLayer) {
      if (item?.event === 'consent_status') {
        console.error('consent_status found in existing dataLayer:', item)
        window.__consentStatus = item
        this.onConsentStatus(item)
        return
      }
    }

    // Intercept future pushes
    this.originalDataLayerPush = window.dataLayer.push

    const self = this
    window.dataLayer.push = function(...args) {
      for (const arg of args) {
        if (arg?.event === 'consent_status') {
          console.error('consent_status intercepted via dataLayer.push:', arg)
          window.__consentStatus = arg
          const r = self.originalDataLayerPush.apply(this, args)
          self.onConsentStatus(arg)
          return r
        }
      }
      return self.originalDataLayerPush.apply(this, args)
    }

    // this.$store.getters['UI/debug'] &&
    //   setTimeout(() => {
    //     // Trigger the consent_status event after 4 second
    //     console.error('(MIXINS) Triggering consent_status...')
    //     window.dataLayer.push({
    //       event: 'consent_status',
    //       consent_status: {
    //         ad_storage: 'granted',
    //         analytics_storage: 'granted',
    //         wait_for_update: 5000
    //       }
    //     })
    //     console.error('(MIXINS) consent_status triggered!')
    //   }, 4000)
  },

  beforeDestroy() {
    if (this.originalDataLayerPush && window.dataLayer) {
      window.dataLayer.push = this.originalDataLayerPush
    }
  },

  methods: {
    // Components using the mixin must implement this
    onConsentStatus(/* eventData */) {
      console.warn('onConsentStatus not implemented in component.')
    }
  }
}
</script>
<style lang="scss" scoped></style>
